module.exports = require("./../internal/prefix") + "parent";
